module.exports = __webpack_public_path__ + "static/img/MacBookPro.c1afcef6.png";